export const SPECS = {
  UseDeliveryOptionsLibInExpress: 'specs.ecom.UseDeliveryOptionsLibInExpress',
  DeliverySectionCheckoutUseDeliverySolutions: 'specs.stores.DeliverySectionCheckoutUseDeliverySolutions',
  ErrorHandlerOnCheckout: 'specs.ecom.ErrorHandlerOnCheckout',
  UseExpressCheckoutSettings: 'specs.ecom.UseExpressCheckoutSettings',
  ParallelPromisesInExpressButtonsInit: 'specs.ecom.ParallelPromisesInExpressButtonsInit',
  SendBIEventOnExpressButtonsPresented: 'specs.ecom.SendBIEventOnExpressButtonsPresented',
  MergeExpressDeliveryRateWithHandlingFee: 'specs.ecom.MergeExpressDeliveryRateWithHandlingFee',
  SupportTaxExemptionOnCheckout: 'specs.ecom.SupportTaxExemptionOnCheckout',
  MakeOnLoadWaitForLoaderToDisappearInExpress: 'specs.ecom.MakeOnLoadWaitForLoaderToDisappearInExpress'
};
//# sourceMappingURL=SPECS.js.map